﻿export class OrderMessage {
    public orderMessageId: number;
    public messageText: string;
    public fromName: string;
    public createdByUserId: string;
    public createdDate: Date;
    public imageUri: string;
    public isFromUser: boolean;
    public referenceId?: string;
}
